// @ts-nocheck

import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';

import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../DOMElements';
import Formatter from '../../i18n/formatter';
import { getCurrency, __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import HelperButton from '../HelperButton';
import Modal from '../Modal';
import ScaleTransitionGroup from '../ScaleTransitionGroup';

const flexRowStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DETaxWrapper = styled.div`
  position: relative;
  width: 100%;
  ${flexRowStyle}
  justify-content: space-between;
`;

const DETaxLeftSide = styled.div`
  ${flexRowStyle}
`;

const DETaxLabel = styled.div`
  margin-right: 0.5em;
  font-size: 90%;
`;

const DETaxRightSide = styled.div`
  ${flexRowStyle}
`;

const DETaxSavedAmount = styled.div`
  position: relative;
  margin-right: 1em;
  color: ${theme.BasketDETaxRow.savedAmountColor};

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: -5%;
    width: 110%;
    height: 1px;
    background: ${theme.BasketDETaxRow.savedAmountColor};
  }
`;

const DETaxFinalAmount = styled.div``;

const DETaxInfosButton = styled(HelperButton)`
  font-size: 75%;
`;

const InfosModalWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: ${theme.BasketDETaxModal.mainColor};
  padding: 1em;
  background: ${theme.BasketDETaxModal.innerBackground};
  border-radius: 1em;
`;

const InfosModalTitle = styled.div`
  font-size: 120%;
`;

const InfosModalDescription = styled.div`
  color: ${theme.BasketDETaxModal.descriptionColor};
  white-space: pre-line;
`;

type BasketSummaryGainDETaxProps = {
  minusDEGainTaxValue: number;
};

const BasketSummaryGainDETax = ({ minusDEGainTaxValue }: BasketSummaryGainDETaxProps) => {
  const [infosModalIsOpen, setInfosModalIsOpen] = useState(false);

  const onToggleInfoButton = useCallback(() => {
    setInfosModalIsOpen(true);
  }, []);

  return (
    <>
      <DETaxWrapper>
        <DETaxLeftSide>
          <DETaxLabel>Gebühr</DETaxLabel>
          <DETaxInfosButton symbol="i" toggled={infosModalIsOpen} onToggle={onToggleInfoButton} />
        </DETaxLeftSide>
        <DETaxRightSide>
          <DETaxSavedAmount>{Formatter.formatNumber(minusDEGainTaxValue, getCurrency())}</DETaxSavedAmount>
          <DETaxFinalAmount>{Formatter.formatNumber(0, getCurrency())}</DETaxFinalAmount>
        </DETaxRightSide>
      </DETaxWrapper>
      {infosModalIsOpen
        ? createPortal(
            <>
              <ScaleTransitionGroup>
                <Modal
                  backgroundColor={theme.BasketFreebetHelper.modalBackgroundColor}
                  closeOnEsc
                  closeOnOutsideClick
                  contentSpacing={ModalContentSpacing.SMALL}
                  format={ModalFormat.XSMALL}
                  hasBorderRadius
                  hasCloseButton
                  hasOverlay
                  onClose={() => setInfosModalIsOpen(false)}
                  blockHeight
                >
                  <InfosModalWrapper>
                    <InfosModalTitle>{__('Bet tax free')}</InfosModalTitle>
                    <InfosModalDescription>{__('!desc:DEBetTaxFreeDescription')}</InfosModalDescription>
                  </InfosModalWrapper>
                </Modal>
              </ScaleTransitionGroup>
            </>,
            getPortalRootDOMElement(),
          )
        : null}
    </>
  );
};

export default BasketSummaryGainDETax;
